
export default function JumpToTop(){
    return (
        <a href="#" class="back-to-top d-flex align-items-center justify-content-center active">
            <box-icon name="chevron-up" type="solid" color="white" size="md"></box-icon>
        </a>
    )
}